import axios from 'axios'
import sha1 from 'js-sha1'
import '../assets/js/layer/layer'
import '../assets/js/layer/need/layer.css'
import store from '../store'
import router from '../router'
import { httpUrl } from '../config'

let returnFlag = false

// 路径
export function getRootUrl () {
  return httpUrl
}

// 移动端根目录
export function getBaseUrl () {
  return window.location.href.replace(window.location.hash, '#/')
}

axios.interceptors.response.use(resp => {
  let data = resp.data
  // 判断token
  const token = resp.headers.token
  if (token) {
    // 更新store和本地缓存的token
    setLocalInfo('userToken', token)
  }
  if (data.status) {
    if (data.status === -3001) {
      removeLocalInfo('userinfo')
      store.commit('userinfo')
      store.commit('logout') // 更改全局登录状态
      toast('登录失效，请重新登录')
      router.push('login')
    } else if (data.status === -2) {
      toast(data.errors.join(','))
      router.push('vipPrice')
    } else {
      return data
    }
  } else {
    toast(data.errors.join(','))
    if (returnFlag) {
      return data
    } else {
      return new Promise(() => {})
    }
  }
}, err => {
  toast('服务器开小差了~')
  console.log(err)
  return { status: 0 }
})

// 请求头里设置token
axios.interceptors.request.use(req => {
  let token = getLocalInfo('userToken')
  if (token) {
    req.headers.token = token
  }
  return req
})

export function get (url, data, flag) {
  // 同意添加平台参数
  url += '?platform=3'
  if (flag === 'needReturn') {
    returnFlag = true
  } else {
    returnFlag = false
  }
  if (data === 'otherUrl') {
    return axios.get(url)
  } else {
    let reqUrl = '/api/' + url
    return axios.get(reqUrl)
  }
}

export function post (url, data, flag) {
  let params = new URLSearchParams()
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      params.append(key, data[key])
    }
  }
  params.append('platform', 3)
  if (flag === 'needReturn') {
    returnFlag = true
  } else {
    returnFlag = false
  }
  if (url.indexOf('https://chat.quanruntong.cn') !== -1) {
    return axios.post(url, params)
  } else {
    let reqUrl = '/api/' + url
    return axios.post(reqUrl, params)
  }
}

export function uploadPost (url, data) {
  return axios.post(url, data)
}

export function md5 (txt) {
  const crypto = require('crypto')
  let md5 = crypto.createHash('md5')
  md5.update(txt)
  return md5.digest('hex')
}

export function toast (msg, time) {
  window.layer.open({
    content: msg,
    skin: 'msg',
    time: time || 2
  })
}

export function showViewLayer (cont) {
  window.layer.open({
    type: 1,
    content: cont,
    style: 'max-width: 90%;padding: 20px;box-sizing: border-box;'
  })
}

// 提示登录
export function isGoLogin (self) {
  if (store.state.user.isLogin) {
    return true
  } else {
    window.layer.open({
      content: '请先登录全润通',
      btn: ['立即登录', '我在想想'],
      yes: function (index) {
        window.layer.close(index)
        store.commit('setGoToUrl', self.$route.path) // 记录用户将要去的目标页面，登录完成后跳到此页面
        self.$router.push('login')
      }
    })
    return false
  }
}

// 设置本地信息
export function setLocalInfo (name, content) {
  try {
    if (typeof content !== 'string') {
      content = JSON.stringify(content)
    }
    localStorage.setItem(name, content)
  } catch (e) {}
}
// 读取本地信息
export function getLocalInfo (name) {
  try {
    return localStorage.getItem(name)
  } catch (e) {}
}
// 移出本地缓存
export function removeLocalInfo (name) {
  try {
    localStorage.removeItem(name)
  } catch (e) {}
}

// 时间戳格式化
export function timeFormat (time = 0, format = 'Y-m-d H:i:s') {
  let date
  if (time) {
    let _time = '' + time
    if (_time.length < 13 || _time.indexOf('.')) {
      time *= 1000
    }
    date = new Date(time)
  } else {
    date = new Date()
  }
  let map = {
    Y: 'getFullYear',
    m: 'getMonth',
    d: 'getDate',
    H: 'getHours',
    i: 'getMinutes',
    s: 'getSeconds'
  }
  for (let i in map) {
    let val = date[map[i]]()
    if (i === 'm') {
      val += 1
    }
    if (val < 10) {
      val = '0' + val
    }
    format = format.replace(i, val)
  }

  return format
}

// 判断是否是微信浏览器
export function isWechatBrowser () {
  // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  let ua = window.navigator.userAgent.toLowerCase()
  // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (JSON.stringify(ua.match(/MicroMessenger/i)) === '["micromessenger"]') {
    return true
  } else {
    return false
  }
}

// 去掉字符串前后的空格
export function baTrim (str) {
  return str.replace(/(^\s*)|(\s*$)/g, '')
}

// 校验手机号码格式是否正确
export function checkMobile (mobile) {
  const filter = /^1\d{10}$/
  return filter.test(mobile)
}

// 微信 js-sdk
export function weChatJssdk (data) {
  let wx = require('weixin-js-sdk')
  wx.config({
    debug: false,
    appId: data.appid,
    timestamp: data.timestamp,
    nonceStr: data.noncestr,
    signature: data.signature,
    jsApiList: ['chooseWXPay']
  })
  return wx
}

// 聊天参数组合
export function combinationParam (param) {
  var tokenTime = new Date().getTime()
  const uid = store.state.user.userinfo.id
  var str = '1' + uid + tokenTime + '58e4024efda9829777c41c4ba85a95f44d848203'
  var p = param || {}
  p.group_id = 1
  p.time = tokenTime
  p.token = sha1(str)
  return p
}



// WEBPACK FOOTER //
// ./src/util/index.js